import React, { Component } from 'react';
import Hero from '../Hero';
import Section01 from '../Section-01';
import Section02 from '../Section-02';
import Section03 from '../Section-03';
import Section04 from '../Section-04';
import Auth0Banner from '../Auth0Banner';
import { MachineToMachineStyled } from './styled.js';

class MachineToMachine extends Component {
  render() {
    const { abExperiments } = this.props;
    return (
      <MachineToMachineStyled>
        <Hero abExperiments={abExperiments} />
        <Section01 />
        <Section02 />
        <Section03 />
        <Section04 />
        <Auth0Banner abExperiments={abExperiments} />
      </MachineToMachineStyled>
    );
  }
}

export default MachineToMachine;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/MachineToMachine/MachineToMachine.js